import { StageCandidateActionType } from 'enums/stageAction';

export const questionAmount: Partial<Record<StageCandidateActionType, number>> =
  {
    [StageCandidateActionType.CognitiveVerablTest]: 4,
    [StageCandidateActionType.CognitiveNumericalTest]: 3,
    [StageCandidateActionType.CognitiveInductiveTest]: 2,
    // One of each kind: a multiple choice and a short answer.
    [StageCandidateActionType.EnglishProficiencyTest]: 2,
  };
